<template>
  <div class="news-contact p-10">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" @click.native="add">添加</el-button>
      </div>
      <div class="search-group">
        <el-input
          placeholder="标题关键词"
          v-model.trim="searchFormData.keyword"
          @keypress.enter.native="search"
        />
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
      >
        <template v-slot:specialized_subject_names="row">
          <div class="one-line" :title="row.specialized_subject_names.join('，')">
            {{row.specialized_subject_names.join('，')}}
          </div>
        </template>
        <template v-slot:action="row">
          <el-button @click="edit(row)" type="text" size="mini">修改</el-button>
          <el-button @click="del(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog
      :title="`${defaultFormItem.id? '编辑' : '新增'}联系信息`"
      :visible.sync="dialogVisible"
      @close="resetForm"
      width="600px"
    >
      <ly-form
        :defaultFormItem="defaultFormItem"
        :formConfig="formConfig"
        :formKeys="formKeys"
        class="contact-form"
        @change="formChange"
        ref="lyFormContact"
      >
        <template v-slot:specialized_subject_ids="{item, formData}">
          <remote-search
            :options="specialized_subject_ids"
            :paramsData="paramsData"
            :defaultData="defaultData"
            @input="(value) => change(value, formData)"
            ref="specialized_subject_ids"
          />
        </template>
      </ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Input } from 'element-ui';
import { frontInf } from '@/api';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { contactTable } from '@/utils/tableHeader';
import { contactFormItem } from '@/utils/formConfig';
import { specialized_subject_id } from '@/utils/formConfigCommon';
import RemoteSearch from '@/components/common/RemoteSearch';

export default {
  name: 'NewsContact',
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    ElDialog: Dialog,
    RemoteSearch
  },
  data() {
    return {
      searchFormData: {
        keyword: ''
      },
      defaultFormItem: {},
      tableHeader: contactTable,
      getTableData: frontInf.getContactInfo,
      formKeys: contactFormItem,
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      dialogVisible: false,
      specialized_subject_ids: {
        ...specialized_subject_id.options,
        clearable: true,
        type: 'select',
        staticResult: [{
          [specialized_subject_id.options.value]: -1,
          [specialized_subject_id.options.label]: '全部项目'
        }],
        multiple: true,
        'collapse-tags': true
      },
      paramsData: {
        org_id: ''
      },
      defaultData: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    resetForm() {
      this.$refs.specialized_subject_ids.clear();
      if (this.$refs.lyFormContact) this.$refs.lyFormContact.resetFields();
    },
    change(value, formData) {
      // eslint-disable-next-line no-param-reassign
      formData.specialized_subject_ids = value;
      if (value.length) {
        if (value[value.length - 1] === -1) {
          // eslint-disable-next-line no-param-reassign
          formData.specialized_subject_ids = [-1];
          this.$refs.specialized_subject_ids.setValue([-1]);
        } else {
          const tmp = value.filter(id => id !== -1);
          // eslint-disable-next-line no-param-reassign
          formData.specialized_subject_ids = tmp;
          this.$refs.specialized_subject_ids.setValue(tmp);
        }
      }
    },
    formChange(formData, key) {
      if (key === 'org_id') {
        if (formData.org_id !== this.paramsData.org_id) {
          this.paramsData = { org_id: formData.org_id };
          this.$refs.specialized_subject_ids.clear();
        }
      }
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyFormContact.getFormData();
      if (!valid) return;
      if (data.specialized_subject_ids[0] === -1) {
        // 全部项目
        data.all_id = 0;
      }
      if (this.defaultFormItem.id) {
        // 修改
        const res = await frontInf.controlContactInfo({
          id: this.defaultFormItem.id,
          params: data,
          methold: 'post'
        });
        if (res) {
          this.$message.success(res.msg || '修改成功！');
          this.dialogVisible = false;
          this.search();
        }
      } else {
        // 新增
        const res = await frontInf.createContactInfo({
          params: data
        });
        if (res) {
          this.$message.success(res.msg || '新增成功！');
          this.dialogVisible = false;
          this.search();
        }
      }
    },
    add() {
      this.dialogVisible = true;
      this.defaultFormItem = {};
    },
    edit(row) {
      this.dialogVisible = true;
      this.defaultFormItem = { ...row };
      const tmp = row.specialized_subject_ids.split(',').map(item => parseInt(item, 10));
      tmp.pop();
      this.defaultData = {
        value: [...tmp],
        options: tmp.map((id, index) => ({ id, full_name: row.specialized_subject_names[index] }))
      };
    },
    del(row) {
      this.$confirm('永久删除该条信息, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          frontInf
            .controlContactInfo({
              id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.news-contact {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
  .one-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-form-item__content {
    overflow: auto;
  }
}
.contact-form {
  .el-input__inner,
  .el-textarea__inner {
    width: 400px;
  }
  .el-input {
    width: auto;
  }
}
</style>
